import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Row, Col } from 'antd';
import { LocalizationContext } from '../../../hoc/Localization';
import TitleContent from '../../TinyComponents/TitleContent';
import MarkDown from '../../TinyComponents/MarkDown';
import styles from '../Info/styles.less';
import Skill from '../Skill';
import Perk from '../Perk';

const Gallery = dynamic(() => import('../../Gallery'));

const Info = ({ description, content, skills, perks, learn, course, mapShow }) => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <Row id="infoContainer" className={styles.row} type="flex">
      {!!description && (
        <Col className={styles.colAbout} sm={12}>
          <div>
            <TitleContent
              title={<h2>{t('course.details.content.about')}</h2>}
              content={<MarkDown source={description} />}
            />
          </div>
        </Col>
      )}

      {!!learn && (
        <Col className={styles.colLearn} sm={12}>
          <TitleContent
            title={<h2>{t('course.details.content.learn')}</h2>}
            content={
              <div>
                <>
                  <Skill skills={skills} />
                  <Perk perks={perks} />
                </>

                <MarkDown source={learn} />
              </div>
            }
          />
        </Col>
      )}

      {!!content && (
        <Col className={styles.col} sm={12}>
          <TitleContent
            title={<h2>{t('course.details.content.content')}</h2>}
            content={<MarkDown source={content} />}
          />
        </Col>
      )}
      {course.images && course.images.length !== 0 && mapShow && (
        <Col className={styles.col} sm={12}>
          <TitleContent
            title={t('details.gallery')}
            content={<Gallery images={course.images} course={course} />}
          />
        </Col>
      )}
    </Row>
  );
};

Info.propTypes = {
  description: PropTypes.string,
  content: PropTypes.string,
  skills: PropTypes.array,
  learn: PropTypes.string,
  course: PropTypes.object,
  perks: PropTypes.array,
  mapShow: PropTypes.bool,
};

Info.defaultProps = {
  description: '',
  content: '',
  skills: [],
  learn: '',
  course: {},
  perks: [],
  mapShow: false,
};

export default Info;
